import React, { FunctionComponent } from 'react'

import { CancellationChart } from '../CancellationChart/CancellationChart'
import { Timeline } from '../Timeline/Timeline'

import { IProps } from './IProps'
import { FlexContainer, PieChartContainer } from './style'

export const AppointmentCharts: FunctionComponent<IProps> = ({
    appointmentReport,
}) => {
    return (
        <FlexContainer>
            <Timeline appointmentStats={appointmentReport} />
        </FlexContainer>
    )
}
